module.exports = __webpack_public_path__ + "static/media/socialMediaApp.a4348c85.jpg";